// src/components/mainchat/ChatBubble.js
// 채팅 버블 스타일 컴포넌트

import React from 'react';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material';



export const ChatBubble = styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'owner',
  })(({ theme, owner }) => ({
    padding: theme.spacing(1.5, 2),
    backgroundColor: owner ? theme.palette.primary.light : theme.palette.background.paper,
    color: owner ? theme.palette.primary.contrastText : theme.palette.text.primary,
    borderRadius: theme.shape.borderRadius * 2,
    maxWidth: '120%',
    minWidth: '100%',
    alignSelf: owner ? 'flex-end' : 'flex-start',
    boxShadow: theme.shadows[1],
    marginBottom: theme.spacing(1),
    
    // 핵심 텍스트 스타일링
    whiteSpace: 'break-spaces', // 줄바꿈과 공백을 모두 유지하면서 줄바꿈 허용
    wordWrap: 'break-word',     // CSS2 호환성을 위한 속성
    overflowWrap: 'break-word', // 긴 단어의 줄바꿈 허용
    wordBreak: 'keep-all',      // 한중일 언어에서 단어 사이에서만 줄바꿈
    
    // CSS text-justify 비활성화
    textJustify: 'none',
    
    // 레이아웃 개선
    display: 'flex',
    flexDirection: 'column',
    width: 'fit-content',      // 내용에 맞게 너비 조정
    
    // 크로스 브라우저 호환성
    WebkitTextSizeAdjust: '100%',
    MozTextSizeAdjust: '100%',
    textSizeAdjust: '100%',
    
    '& p': {                   // 내부 단락에 대한 스타일
      margin: 0,
      padding: 0,
      wordBreak: 'keep-all',   // 단락 내에서도 단어 사이에서만 줄바꿈
    }
  }));
  
  
  

export default ChatBubble;